/**
 * Node types that are not supported for running models
 * These nodes will show an error message when selected for running
 */
export const UNSUPPORTED_NODE_TYPES = ['painter', 'masks', 'deprecated'] as const;

/**
 * Node types that should be ignored when running selected nodes
 * These nodes will be silently filtered out from the selection
 */
export const IGNORE_NODE_TYPES = ['stickynote', 'custom_group'] as const;

export const ITERATOR_NODE_TYPES = ['muxv2', 'media_iterator'] as const;

export const PROMPT_NODE_ID = 'jzXJ8QEfxQm2sZfvzu7q';

export const IMPORT_NODE_DEFINITION_ID = 'wkKkBSd0yrZGwbStnU6rClone';

export const LIST_SELECTOR_NODE_ID = 'K4Bi14QsmaOKQMHpZstoClone';

export const CAMERA_NODE_DEFINITION_ID = '157202ac-23bc-4446-8900-c0bc9d2868e3';

export const IMPORT_MODEL_NODE_ID = 'RGDNWgeo7rDYAhTlOtXD';

export const FLUX_FAST_ID = 'zE9WAgeGgEYnZmIspEGn';

// ChatGPT Images 2.0 has divergent NodeDefinition ids between Weavy environments:
// `zeSQQxxjcaVdWWunD60J` in dev (matches `weavy/core/src/migrations/menu.json` seed,
// served by api.dev.weavy.ai to Figma staging) and `zeSQQxxjcaVdWWunD60J1` in prod
// (served by api.weavy.ai). Both are exported so the tour anchor fallback resolves
// in either environment.
export const CHATGPT_IMAGES_2_DEV_ID = 'zeSQQxxjcaVdWWunD60J';
export const CHATGPT_IMAGES_2_PROD_ID = 'zeSQQxxjcaVdWWunD60J1';
